module.exports = __webpack_public_path__ + "static/preview-img3@2x-0f2b6c299f59d9ebb299a82af5a25a2f.png";